















import { AgeManagerService } from "@/common/api";
import CustomerUser from "@/model/customerUser";
import router from "@/router";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const authStore = namespace("Auth");

@Component({
  name: "Error",
})
export default class Error extends Vue {
  @authStore.Getter
  public getUserType!: string;
  @authStore.Getter
  public getCustomerUser!: CustomerUser;
  public reload() {
    window.location.reload();
  }

  public async mounted(): Promise<void> {
    const result = await AgeManagerService.adminAge({}).then(() =>
      router.push({ name: "admin.default" }),
    );
  }
}
